import React from "react";
import dayjs from "dayjs";
import { PackagesFlightShopStep } from "redmond";

export const SEARCHING_FOR_FLIGHTS = "for flights";

export const getShortLabel = (label: string) => {
  return label.split(",")[0].replace(/ \(\d Airports\)/, "");
};

export const CHOOSING_FLIGHT_TEXT = (
  currentStep: PackagesFlightShopStep,
  origin: string,
  destination: string,
) => {
  const isOutgoing = currentStep === PackagesFlightShopStep.ChooseDeparture;

  return `Choose ${isOutgoing ? "outbound" : "return"} flight to ${
    isOutgoing ? getShortLabel(destination) : getShortLabel(origin)
  }`;
};

export const SHOW_MORE_NUM = 5;
export const INITIAL_RESULT_SET_SIZE = 10;

export const getStopsString = (stops: number) =>
  stops === 0 ? "Nonstop" : stops > 1 ? `${stops} stops` : "1 stop";

/**
 * @deprecated Use getEarnTag from the common module instead.
 * This function returns a string with HTML markup which is not safe.
 * The getEarnTag function provides a safer alternative using JSX.
 */
export const getEarnTagText = (earnRate: string | number) =>
  `<span class="font-bold">Earn ${earnRate}X</span> miles on flights`;

export const RECOMMENDED_FLIGHT_LIST_SEPARATOR_PRIMARY_TEXT =
  "Below are all remaining flights available for this route.";

export const RECOMMENDED_FLIGHT_LIST_SEPARATOR_SECONDARY_TEXT =
  "Total price will vary based on final flight selection.";

export const RECOMMENDED_FLIGHT_BANNER_TEXT =
  "Package price includes this recommended flight";

export const CORPORATE_RECOMMENDED_FLIGHT_BANNER_TEXT =
  "Total price shown includes this recommended flight";

export const REWARDS_BANNER_TEXT = "Prices are round-trip, per traveler";

export const LOADING_FLIGHT_DETAILS_STRING = "Loading Flight Details";

export const STAY_LENGTH_TEXT = (
  outgoingArrivalDate: string,
  returnDepartureDate: string,
  packageStayLengthBasedOnFare: number,
  packageStayLengthBasedOnAvailability: number | null,
  packageStayLengthBasedOnOutboundFlight: number | null,
  isOutgoing: boolean,
) => {
  const comparisonStayLength =
    packageStayLengthBasedOnOutboundFlight ??
    packageStayLengthBasedOnAvailability;
  return (
    <>
      {isOutgoing
        ? getFlightArrivalText(outgoingArrivalDate)
        : getFlightDepartureText(returnDepartureDate)}{" "}
      {getStayLengthText(packageStayLengthBasedOnFare, comparisonStayLength)}
      {getPriceChangeDisclaimerText(
        packageStayLengthBasedOnFare,
        comparisonStayLength,
      )}
    </>
  );
};

const getFlightArrivalText = (outgoingArrivalDate: string) =>
  `Flight arrives ${dayjs(outgoingArrivalDate).format("MMM D")} at ${dayjs(
    outgoingArrivalDate,
  ).format("h:mma")}.`;

const getFlightDepartureText = (returnDepartureDate: string) =>
  `Flight departs ${dayjs(returnDepartureDate).format("MMM D")} at ${dayjs(
    returnDepartureDate,
  ).format("h:mma")}.`;

const getStayLengthText = (
  stayLength: number,
  comparisonStayLength: number | null,
) => {
  return (
    <>
      Package includes{" "}
      <strong>
        {stayLength} hotel night
        {stayLength === 1 ? "" : "s"}
      </strong>
      {stayLength !== comparisonStayLength
        ? ` instead of ${comparisonStayLength}`
        : ""}
      .
    </>
  );
};

const getPriceChangeDisclaimerText = (
  stayLength: number,
  comparisonStayLength: number | null,
) => {
  return (
    comparisonStayLength != null &&
    stayLength !== comparisonStayLength &&
    `${" "}${PRICE_CHANGE_DISCLAIMER_TEXT}`
  );
};

const PRICE_CHANGE_DISCLAIMER_TEXT =
  "Choosing this flight may affect total price.";
